import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import { FiDroplet, FiPlus, FiMinus } from 'react-icons/fi';

const QUICK_ADD = [8, 16, 24, 32];
const GOAL = 64;

export default function StepWater({ data, onChange }) {
  const water = data.water || 0;
  const percent = Math.min(100, (water / GOAL) * 100);
  const circumference = 2 * Math.PI * 50;

  return (
    <div className="space-y-6">
      <p className="font-sans text-sm text-slate-500">Track your hydration for the day.</p>

      {/* Circle Display */}
      <div className="glass-card rounded-[2rem] p-8 flex flex-col items-center">
        <div className="relative w-40 h-40 mb-6">
          <svg viewBox="0 0 120 120" className="w-full h-full -rotate-90 drop-shadow-md">
            <defs>
              <linearGradient id="waterGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#06b6d4" />
              </linearGradient>
            </defs>
            <circle
              cx="60" cy="60" r="50"
              fill="none"
              stroke="rgba(219,234,254,0.7)"
              strokeWidth="8"
            />
            <circle
              cx="60" cy="60" r="50"
              fill="none"
              stroke="url(#waterGrad)"
              strokeWidth="8"
              strokeDasharray={circumference}
              strokeDashoffset={circumference * (1 - percent / 100)}
              strokeLinecap="round"
              style={{ transition: 'stroke-dashoffset 0.6s cubic-bezier(0.4, 0, 0.2, 1)' }}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <SafeIcon icon={FiDroplet} className="text-blue-500 text-2xl mb-1" />
            <span className="font-sans font-medium text-4xl text-slate-900 tracking-tight">{water}</span>
            <span className="font-sans text-xs uppercase font-bold tracking-widest text-slate-400">oz</span>
          </div>
        </div>

        <p className={`font-sans text-sm font-medium ${water >= GOAL ? 'text-slate-900' : 'text-slate-500'}`}>
          {water >= GOAL ? '🎉 Daily goal met!' : `${GOAL - water}oz to reach your goal`}
        </p>

        {/* +/- Controls */}
        <div className="flex items-center gap-6 mt-8">
          <button
            onClick={() => onChange({ water: Math.max(0, water - 8) })}
            className="w-12 h-12 rounded-full glass-input flex items-center justify-center text-slate-700 active:scale-95 transition-transform"
          >
            <SafeIcon icon={FiMinus} className="text-xl" />
          </button>
          <span className="font-sans font-medium text-slate-800 w-16 text-center">{water} oz</span>
          <button
            onClick={() => onChange({ water: water + 8 })}
            className="w-12 h-12 rounded-full bg-slate-900 flex items-center justify-center text-white shadow-lg active:scale-95 transition-transform"
          >
            <SafeIcon icon={FiPlus} className="text-xl" />
          </button>
        </div>
      </div>

      {/* Quick Add */}
      <div>
        <p className="font-sans text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">Quick Add</p>
        <div className="grid grid-cols-4 gap-2">
          {QUICK_ADD.map(oz => (
            <button
              key={oz}
              onClick={() => onChange({ water: water + oz })}
              className="glass-card rounded-2xl py-3 text-center active:scale-95 transition-transform"
            >
              <p className="font-sans text-sm font-medium text-slate-800">+{oz}</p>
              <p className="font-sans text-xs text-slate-500 font-semibold uppercase">oz</p>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}